import { useTheme } from '../../hooks/useTheme'
import type { ReactNode, ButtonHTMLAttributes } from 'react'

interface IconButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'style'> {
  children: ReactNode
  variant?: 'primary' | 'secondary' | 'brand'
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const sizeClasses = {
  sm: 'w-9 h-9 text-base',
  md: 'w-11 h-11 text-xl',
  lg: 'w-14 h-14 text-2xl',
}

export function IconButton({
  children,
  variant = 'primary',
  size = 'md',
  className = '',
  ...props
}: IconButtonProps) {
  const theme = useTheme()
  
  const variantStyles = {
    primary: {
      backgroundColor: theme.accent.medium,
      border: `1px solid ${theme.accent.border}`,
      color: theme.accent.text,
    },
    secondary: {
      backgroundColor: theme.cardBg,
      border: `1px solid ${theme.cardBorder}`,
      color: theme.textColor,
    },
    brand: {
      backgroundColor: theme.brand.medium,
      border: `1px solid ${theme.brand.border}`,
      color: theme.brand.solid,
    },
  }
  
  return (
    <button
      className={`
        rounded-full flex items-center justify-center
        transition-opacity hover:opacity-80 active:opacity-70
        ${sizeClasses[size]}
        ${className}
      `}
      style={variantStyles[variant]}
      {...props}
    >
      {children}
    </button>
  )
}
